<template>
    <div>
        <member-filter-link :filterLayout="filterLayout" :filterData="filterSet.filter"
                            :paginationData="filterSet.page"></member-filter-link>
        <member-list-link :listLayout="listLayout" :paginationData="filterSet.page"
                          :memberData="List"></member-list-link>
        <pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page" :listLength="List.length"
                         :finishGetList="finishGetList"></pagination-link>
    </div>
</template>

<script>
import MemberFilterLink from "@/components/member/MemberFilterLink";
import MemberListLink from "@/components/member/MemberListLink";
import PaginationLink from "@/components/member/PaginationLink";
import memberUtil from "@/components/member/memberUtil";
import filterMixins from "@/mixins/filterMixins";
import listMixins from "@/mixins/listMixins";
import util from "@/mixins/util";
import alertMixins from "@/mixins/alertMixins";
import EventBus from "@/utils/event-bus";

const {filterConfig} = memberUtil;

export default {
    name: "MemberListCouponModalComponent",
    mixins: [memberUtil, filterMixins, listMixins, alertMixins],
    components: {MemberFilterLink, MemberListLink, PaginationLink},
    provide() {
        return {
            setPage: this.setPage,
            setFilter: this.setFilter,
        }
    },
    inject: ['changeLoading'],
    props: {
        memberType: {default: ''},
        memberKey: '',
        langOption:'',
    },
    data() {
        return {
            listLayout: '',
            filterLayout: '',
            paginationLayout: '',
            getFunc: '',
            listApiParamSet: {},
            postFunc: '',
            parsingData: {}
        }
    },
    created() {
        this.initConfig();
        this.setFilterConfig(filterConfig)
        this.setParserType('url', this.$route.fullPath);
    },
    mounted() {
        this.getList(true);
        EventBus.$on('giveCoupon', this.giveCoupon);
    },
    beforeDestroy() {
        EventBus.$off('giveCoupon');
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(type, value) {
            this[type] = value;
        },
        initConfig() {
            let config = this.returnMemberConfig(this.memberType)
            this.listLayout = config.listLayout;
            this.filterLayout = config.filterLayout;
            this.paginationLayout = config.paginationLayout;
            this.getFunc = config.getFunc;
            this.listApiParamSet = config.listApiParamSet;
            this.postFunc = config.postFunc;
            this.parsingData = config.parsingData;
            let params = JSON.parse(JSON.stringify(this.listApiParamSet));

            params.ml = this.langOption;

            let listOptions = {
                url: this.$api.$member[this.getFunc],
                defaultParams: params,
            }
            if (config.pageRow && config.pageRow != this.filterSet.page.size) {
                this.pageRow = config.pageRow;
                this.filterSet.page.size = config.pageRow;
                this.pageClass.setterPage('size', this.pageRow);
            }

            this.initList('api', listOptions);
        },
        giveCoupon(id) {
            this.createConfirm({
                content: '해당 회원에게 즉시 쿠폰이 발급됩니다.<br>정말 발급하시겠습니까?',
                confirm: () => {
                    let params = {}
            
                    params.c_idx = this.$route.params.idx
                    params.mb_no = id

                    try {
                        this.$api.$coupon[this.postFunc](params).then(res => res.Data.Result).then(res => {
                            if(res.Info.type == 1) {
                                console.log(res);
                                this.closeModal()
                              EventBus.$emit('getList')
                            } else {
                                this.errorAlert(res.Info.reason);
                            }
                        })
                    } catch(e) {
                        this.changeLoading(false);
                        console.log(e);
                    }
                },
                cancel: () => {

                }
            })

            
        },

      closeModal() {
        this.$modal.hide('coupon-member-list-modal')
      },


    },
    watch: {
    },
}
</script>

<style scoped>

</style>
